<div class="fix-left-section-container">
  <div class="share-section mb-4">
    <div class="share-text mb-2">شارك المقال على</div>
    <div class="social-icons d-flex justify-content-end gap-2">
      <a href="#" class="social-icon">
        <i class="fa-brands fa-twitter"></i>
      </a>
      <a href="#" class="social-icon">
        <i class="fa-brands fa-facebook-f"></i>
      </a>
    </div>
  </div>

  <div class="watch-also-wrapper position-relative">
    <div class="green-backdrop"></div>
    <div class="gray-content-card">
      <h4 class="section-title mb-4">شاهد ايضا</h4>
      <ul class="custom-list p-0 m-0">
        <li>
          <a [routerLink]="'/economicPerformance'" routerLinkActive="active">
            القطاعات المستهدفة
          </a>
        </li>
        <li>
          <a [routerLink]="'/agreements'" routerLinkActive="active">
            الإتفاقيات التجارية
          </a>
        </li>
        <li>
          <a [routerLink]="'/mining'" routerLinkActive="active">
            قطاع التعدين
          </a>
        </li>
        <li>
          <a [routerLink]="'/it'" routerLinkActive="active">
            قطاع الاتصالات وتكنولوجيا المعلومات
          </a>
        </li>
        <li>
          <a [routerLink]="'/realState'" routerLinkActive="active">
            قطاع العقارات
          </a>
        </li>
        <li>
          <a [routerLink]="'/healthcare'" routerLinkActive="active">
            قطاع الرعاية الصحية
          </a>
        </li>
        <li>
          <a [routerLink]="'/financial'" routerLinkActive="active">
            قطاع الخدمات المالية والتأمين
          </a>
        </li>
        <li>
          <a [routerLink]="'/education'" routerLinkActive="active">
            قطاع التعليم
          </a>
        </li>
        <li>
          <a [routerLink]="'/pharmaceutical'" routerLinkActive="active">
            قطاع الصناعات الدوائية والطبية
          </a>
        </li>
        <li>
          <a [routerLink]="'/tourism'" routerLinkActive="active">
            قطاع السياحة
          </a>
        </li>
        <li>
          <a [routerLink]="'/agriculture'" routerLinkActive="active">
            قطاع الزراعة واستصلاح الأراضي
          </a>
        </li>
        <li>
          <a [routerLink]="'/textiles'" routerLinkActive="active">
            قطاع الغزل والنسيج
          </a>
        </li>
        <li>
          <a [routerLink]="'/oilgas'" routerLinkActive="active">
            قطاع الغاز والبترول
          </a>
        </li>
        <li>
          <a [routerLink]="'/foodprocessing'" routerLinkActive="active">
            قطاع الصناعات الغذائية
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>